import { Box, Flex } from "@chakra-ui/react";
import React from "react";
import CustomHeading from "../../components/text/CustomHeading";
import CustomText from "../../components/text/CustomText";
import FormInput from "../../components/form/FormInput";
// import IconChevDown from "../../svgs/IconChevDown";
import CustomPhoneInput from "../../components/form/PhoneInput";
import { useSelector } from "react-redux";
import IconChevDown from "../../svgs/IconChevDown";
import { IconCheck } from "@tabler/icons-react";

function CompanyInfo({ payload, setPayload }: any) {
  const [isCountryOpen, setIsCountryOpen] = React.useState(false);

  const { countries } = useSelector((state: any) => state.general);

  return (
    <Flex
      flexDir="column"
      gap="22px"
      maxW="666px"
      minH="521px"
      w="100%"
      mx="auto"
    >
      <CustomHeading text="Company Info" family="aeonik-bold" align="center" />
      <CustomText
        text="Enter Company Info of the exhibitor"
        align="center"
        color="yess.neutral600"
      />
      <Flex gap="22px">
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Company Name" size="12px" />
          <FormInput
            ph="Enter Company Name"
            maxW="322px"
            value={payload?.companyName}
            onChange={(e: any) =>
              setPayload({ ...payload, companyName: e.target.value })
            }
          />
        </Flex>
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Job Title" size="12px" />
          <FormInput
            ph="Enter Job Title"
            maxW="322px"
            value={payload?.jobTitle}
            onChange={(e: any) =>
              setPayload({ ...payload, jobTitle: e.target.value })
            }
          />
        </Flex>
      </Flex>
      <Flex flexDir="column" gap="11px" w="100%">
        <CustomText text="Company Email" size="12px" />
        <FormInput
          ph="Enter Email"
          type="email"
          value={payload?.companyEmail}
          onChange={(e: any) =>
            setPayload({ ...payload, companyEmail: e.target.value })
          }
        />
      </Flex>
      <Flex gap="22px">
        <Flex flexDir="column" gap="11px" w="100%">
          <Box pos="relative" w="100%">
            <Flex
              flexDir="column"
              gap="11px"
              w="100%"
              cursor="pointer"
              onClick={() => {
                setIsCountryOpen(!isCountryOpen);
              }}
            >
              <CustomText text="Company Location" size="12px" />
              <Flex
                px="24px"
                h="38px"
                align="center"
                justify="space-between"
                bg="#f2f2f2"
                borderRadius="8px"
              >
                <CustomText
                  text={payload?.companyLocation || "Select Location"}
                  size="14px"
                  color="yess.neutral_black"
                />
                <IconChevDown />
              </Flex>
            </Flex>
            <Flex
              flexDir="column"
              gap="12px"
              p="12px 24px"
              bg="#f2f2f2"
              borderRadius="12px"
              pos="absolute"
              mt="5px"
              w="100%"
              zIndex="1000"
              display={isCountryOpen ? "flex" : "none"}
              boxShadow={`0px 4px 4px rgba(0, 0, 0, 0.25)`}
            >
              {countries?.map((country: any, idx: number) => (
                <Flex
                  key={idx}
                  align="center"
                  cursor="pointer"
                  justify="space-between"
                  onClick={() => {
                    setIsCountryOpen(false);
                    setPayload({ ...payload, companyLocation: country?.name });
                  }}
                >
                  <CustomText
                    text={country?.name}
                    size="12px"
                    color="yess.nuetral900"
                    cursor="pointer"
                  />
                  {payload?.companyLocation === country?.name && (
                    <IconCheck size="12px" color="#000000" />
                  )}
                </Flex>
              ))}
            </Flex>
          </Box>
        </Flex>

        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Company Phone Number" size="12px" />
          <CustomPhoneInput
            value={payload?.companyPhone}
            onChange={(e: any) => {
              setPayload({ ...payload, companyPhone: e });
            }}
          />
        </Flex>
      </Flex>
      <Flex flexDir="column" gap="11px" w="100%">
        <CustomText text="Address" size="12px" />
        <FormInput
          ph="Enter Address"
          value={payload?.companyAddress}
          onChange={(e: any) =>
            setPayload({ ...payload, companyAddress: e.target.value })
          }
        />
      </Flex>
      <Flex gap="22px">
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="City" size="12px" />
          <FormInput
            ph="Enter City Name"
            maxW="322px"
            value={payload?.companyCity}
            onChange={(e: any) =>
              setPayload({ ...payload, companyCity: e.target.value })
            }
            // rightIco={<IconChevDown />}
          />
        </Flex>
        <Flex flexDir="column" gap="11px" w="100%">
          <CustomText text="Zip Code" size="12px" />
          <FormInput
            ph="Enter Zip Code"
            maxW="322px"
            value={payload?.companyZipCode}
            onChange={(e: any) =>
              setPayload({ ...payload, companyZipCode: e.target.value })
            }
          />
        </Flex>
      </Flex>
    </Flex>
  );
}

export default CompanyInfo;
